import React, { Fragment, useCallback, useState } from 'react';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import {
    Col,
    Button,
    FormGroup,
    Label,
    Form,
    Modal,
    ModalHeader,
    ModalBody,
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../Context/Auth/AuthContext';

export default function ModalRequestCall(props) {
    const { modalRequestCall, toggleModalCallRequest, giver } = props;
    const { currentGroup, toggleLoading } = useAuth();

    const [date, setDate] = useState(new Date());
    const toggleDate = useCallback(
        (date) => {
            setDate(date);
        },
        [setDate]
    );

    const { handleSubmit } = useForm({});

    const onSubmitRequestCall = useCallback(
        async (data) => {
            toggleLoading(true);
            api.post(`/ro.team.requestCall`, {
                giverId: giver.id,
                groupId: currentGroup.id,
                date: moment(date).format('YMMDDHHmm'),
            })
                .then((response) => {
                    toast.success(`Successfully requested!`);
                    toggleModalCallRequest();
                })
                .catch((err) => {
                    toast.error('Something wrong.');
                })
                .finally(() => {
                    toggleLoading(false);
                });
        },
        [currentGroup.id, toggleLoading, toggleModalCallRequest, date, giver]
    );

    return (
        <Fragment>
            <Modal isOpen={modalRequestCall} toggle={toggleModalCallRequest}>
                <ModalHeader toggle={toggleModalCallRequest}>
                    Request Call
                </ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup row>
                            <Label for="date" sm={2}>
                                Date
                            </Label>
                            <Col sm={10}>
                                <DatePicker
                                    selected={date}
                                    onChange={toggleDate}
                                    showTimeSelect
                                    className="form-control"
                                    timeFormat="p"
                                    timeIntervals={30}
                                    dateFormat="MMMM d, yyyy h:mm aa"
                                    timeCaption="Time"
                                    minDate={new Date()}
                                />
                            </Col>
                        </FormGroup>
                        <div className="text-center">
                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="info"
                                onClick={handleSubmit(onSubmitRequestCall)}
                            >
                                OK
                            </Button>

                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="secondary"
                                onClick={toggleModalCallRequest}
                            >
                                Cancel
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </Fragment>
    );
}
